export default __webpack_public_path__ + "8583fb076895d267edefc900e8b8954b.woff";